<template>
  <form class="form-inline search-form w-100 mt-2 mt-md-0" @submit.prevent="search">
    <div class="position-relative w-100">
    <input ref="searchBar" @input="search" class="form-control pr-5 w-100" type="text" placeholder="Search" aria-label="Search" v-model="searchText">
    <i v-if="searchText" @click="clearField" class="fas fa-times close-icon"></i>
    <i @click="search" class="fas fa-search search-icon"></i>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      searchText: this.$page.props.query || '',
      inCustom: false
    }
  },
  props: {
    categoryRoute: String,
    shopRoute: String,
  },
  mounted() {
    if (this.searchText || window.location.href.includes('query=')) this.$refs.searchBar.focus()
    if (this.$page.props.custom) this.inCustom = true
  },
  methods: {
    search() {
      let queryObject = this.mergeQueryParams({ 
        query: this.searchText,
        manufacturer: this.$page.props.manufacturer_id
      })

      if(this.searchText === '*') {
        this.searchText = '';
        this.$refs.searchBar.blur();
        if (this.$page.props.category_id === this.$page.props.const.cat_all) return

        if (this.$page.props.const.cat_all) {
          this.$inertia.visit(route(this.categoryRoute, {
            category: this.$page.props.const.cat_all,
          }))
        }
        return
      }

      if (this.inCustom) queryObject.custom = 1

      if (this.$page.props.category_id) {
        this.$inertia.visit(route(this.categoryRoute, {
          category: this.$page.props.category_id, _query: queryObject
        }))
      } 
      else {
        this.$inertia.visit(route(this.shopRoute, {_query: queryObject }))
      }        
    },
    clearField() {
      this.searchText = ''
      this.search()
    }
  }
}
</script>

<style>
  .search-form .search-icon {
    position: absolute;
    top: 12px;
    right: 20px;
    cursor: pointer;
  }

  .search-form .close-icon {
    position: absolute;
    top: 13px;
    right: 42px;
    font-size: 12px;
  }
</style>
